import React from 'react';
import { number, string } from 'prop-types';
import { quotesPropType } from '../../utils/propTypes';
import QuotesDetailsBox from './QuotesDetailsBox';

const QuotesCompactList = ({ quotes, maxListSize, componentId }) => {
  return (
    <div className="sui-flex sui-flex-col sui-gap-3 sui-mb-8">
      {quotes?.slice(0, maxListSize).map((quote, index) => (
        <QuotesDetailsBox
          key={`${quote.cartId}-${index}`}
          quote={quote}
          fullWidth
          index={index}
          componentId={componentId}
        />
      ))}
    </div>
  );
};

QuotesCompactList.propTypes = {
  maxListSize: number,
  quotes: quotesPropType,
  componentId: string,
};

QuotesCompactList.defaultProps = {
  maxListSize: 3,
  quotes: [],
  componentId: '',
};

export default QuotesCompactList;
